<template>
  <div class="modal fade" id="import-notifications" aria-hidden="false" aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t('automation.index.import_notifications_title') }}
                </h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#import-notifications')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row-mt-15">
            <div class="col-7 text-center">
              <img src="static/assets/images/SuperHote_icons/warning-2.svg" alt="" width="40">
              <p class="mt-15 notification-desc">{{ $t('automation.index.import_notifications_desc') }}</p>
            </div>
          </div>
        </div>
        <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn waves-effect waves-classic btn-cancel"
            @click.prevent="closeModal('#import-notifications')"
            data-dismiss="modal"
            :disabled="smallLoading"
          >
            {{ $t('button.cancel') }}
          </button>
          <div class="upload">
            <button
              type="submit"
              class="btn btn-primary waves-effect waves-classic btn-save"
              :disabled="smallLoading"
            >
              {{ $t('button.yes_import') }}
            </button>
            <form enctype="multipart/form-data" v-if="!smallLoading">
              <input type="file" @change="importNotifications" multiple class="import-notifications">
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mixin from "../../../mixins/mixin";
  import automationService from "../../../services/automation";

  export default {
    name: "importNotificationsModal",
    data() {
      return {
        smallLoading: false
      }
    },
    components: {
      VLoading: require('components/loading/loading.vue'),
    },
    mixins: [mixin],
    methods: {
      async importNotifications(event) {
        this.smallLoading = true;
        const files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        let formData = new FormData();
        formData.append('csvFile', files[0]);
        formData.append('folder', 'forms');

        await automationService.importNotifications(this, formData);
        await this.$emit('getAutoActions');
      }
    }
  }
</script>

<style scoped>
  .notification-desc {
    font-size: 13px;
  }

  .upload {
    position: relative;
  }

  .upload button {
    position: relative;
    z-index: 1;
  }

  .upload form input[type] {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 2;
    left: 0;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// importNotificationsModal.vue?5a88905f